import React, { useState, useEffect, useMemo, useCallback } from 'react';

const TeeSheetModal = (props) => {
    const [bookingSheet, setBookingSheet] = useState([]);
    const [activeTeeBox, setActiveTeeBox] = useState(1);

    useEffect(() => {
        $('#modalBookSheet').modal();
        $('#modalBookSheet').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal(false);
        });
    }, []);

    // ✅ Memoized processing of tee sheet data
    const processedTeeSheets = useMemo(() => {
        if (!props?.teeSheet || !props?.bookingUsers) return { 1: [], 10: [] };

        const teeBox1Data = {};
        const teeBox10Data = {};

        props.teeSheet.forEach((slot) => {
            const users = props.bookingUsers.filter(u => u.TeeTimeBookID === slot.ID);
            const userString = users
                .map(u => `${u.UserName} (${u.UserType === 'User' ? u.MembershipNo : 'G'})`)
                .join(', ');

            const targetData = slot.TeeBox === 1 ? teeBox1Data : teeBox10Data;
            
            if (targetData[slot.Slot]) {
                // Merge users for same slot
                targetData[slot.Slot].users.push(...users);
                if (userString) {
                    targetData[slot.Slot].userString = targetData[slot.Slot].userString 
                        ? `${targetData[slot.Slot].userString}, ${userString}`
                        : userString;
                }
            } else {
                // First occurrence of this slot
                targetData[slot.Slot] = {
                    ...slot,
                    users: [...users],
                    userString: userString
                };
            }
        });

        // Convert to arrays and add userCount
        const processSheet = (data) => 
            Object.values(data).map(item => ({
                ...item,
                userCount: item.users?.length || 0
            }));

        return {
            1: processSheet(teeBox1Data),
            10: processSheet(teeBox10Data)
        };
    }, [props.teeSheet, props.bookingUsers]);

    // ✅ Optimized filter function with useCallback
    const filterTeeSheet = useCallback((teeBox) => {
        setActiveTeeBox(teeBox);
        setBookingSheet(processedTeeSheets[teeBox] || []);
        
        // Update button styles
        updateButtonStyles(teeBox);
    }, [processedTeeSheets]);

    // ✅ Separated button styling logic
    const updateButtonStyles = (activeTee) => {
        const btn1 = $('#btnTeeBox1');
        const btn10 = $('#btnTeeBox10');
        
        if (activeTee === 1) {
            btn1.removeClass('btn-default').addClass('btn-success');
            btn10.removeClass('btn-success').addClass('btn-default');
        } else {
            btn10.removeClass('btn-default').addClass('btn-success');
            btn1.removeClass('btn-success').addClass('btn-default');
        }
    };

    // ✅ Initialize with default tee box
    useEffect(() => {
        filterTeeSheet(1);
    }, [filterTeeSheet]);

    // ✅ Memoized availability display component
    const AvailabilityDisplay = React.memo(({ booking }) => {
        const availableSlots = 4 - Number(booking.userCount);
        if(booking.OwnerType == 'Admin' && booking.Status !== 'Booked') {
            return (
                <span>
                    Not Available 
                    <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>
                </span>
            );
        } else if (availableSlots === 4) {
            return (
                <span>
                    Available 
                    <i className="fa fa-check-circle-o text-green fa-lg margin-lr10" aria-hidden="true"></i>
                </span>
            );
        } else if (availableSlots > 0) {
            return (
                <span>
                    Available {availableSlots}
                    <i className="fa fa-check-circle-o text-green fa-lg margin-lr10" aria-hidden="true"></i>
                </span>
            );
        } else {
            return (
                <span>
                    Booked
                    <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>
                </span>
            );
        }
    });

    // ✅ Memoized booking row component
    const BookingRow = React.memo(({ booking, index }) => (
        <tr key={`${booking.Slot}-${index}`}>
            <td>
                <div className="padding-lr20">
                    <div className="row row-flex-warp">
                        <div className="col-xs-6">
                            <span><b>{booking.Slot}</b></span>
                        </div>
                        <div className="col-xs-6 text-right">
                            <AvailabilityDisplay booking={booking} />
                        </div>
                    </div>
                    {booking.Status && (
                        <div className="row row-flex-warp">
                            <div className="col-xs-12">
                                <span>
                                    {booking.Status === 'Booked' ? booking.userString : booking.Status}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    ));

    return (
        <div id="modalBookSheet" className="modal fade modal-responsive" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header padding-b0">
                        <button type="button" className="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-header padding-b5">
                        {/* Tee Box Selection */}
                        <div id="pnlTeeBtn" className="row padding-lr10">
                            <div className="col-xs-6">
                                <button 
                                    id="btnTeeBox1" 
                                    type="button" 
                                    className={`btn btn-block ${activeTeeBox === 1 ? 'btn-success' : 'btn-default'}`}
                                    onClick={() => filterTeeSheet(1)}
                                >
                                    1st Tee
                                </button>
                            </div>
                            <div className="col-xs-6">
                                <button 
                                    id="btnTeeBox10" 
                                    type="button" 
                                    className={`btn btn-block ${activeTeeBox === 10 ? 'btn-success' : 'btn-default'}`}
                                    onClick={() => filterTeeSheet(10)}
                                >
                                    10th Tee
                                </button>
                            </div>
                        </div>
                        
                        {/* Date Display */}
                        <div className="row margin-b5 margin-t20">
                            <div className="col-xs-12 text-center">
                                <h6 className="margin-tb0">
                                    <i className="fa fa-calendar input-group-text margin-r5"></i>
                                    <b id="bookingDate">{props?.selectedDate}</b>
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="modal-body padding-t0">
                        <div className="panel panel-default panel-club margin-t10">
                            <table id="tblBookSheet" className="table table-striped">
                                <tbody>
                                    {bookingSheet.length > 0 ? (
                                        bookingSheet.map((booking, index) => (
                                            <BookingRow 
                                                key={`${booking.Slot}-${index}`} 
                                                booking={booking} 
                                                index={index} 
                                            />
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="text-center padding-20">
                                                <span className="text-muted">No bookings available for selected tee</span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeeSheetModal;